import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { WrapperBackgroundColor, NumberBackgroundColor, BorderColor } =
  themeColorSectionKeys.Settings.BlockedNumbers

const BlockedNumberStyleParts = [
  'outerWrapper',
  'wrapper',
  'headerWrapper',
  'header',
  'numberWrapper',
  'headerText',
  'headerSubtext',
  'blockedNumberWrapper',
  'blockedNumberText',
  'modal',
] as const

const helpers = createMultiStyleConfigHelpers(BlockedNumberStyleParts)

export const BlockedNumberStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    outerWrapper: {
      width: '35.5rem',
      minHeight: '10%',
      padding: '1rem',
      maxHeight: '100%',
      flexShrink: 0,
      borderRadius: '0.25',
    },
    wrapper: {
      flex: 1,
      borderRadius: '0.25rem',
      display: 'flex',
      backgroundColor: WrapperBackgroundColor,
      borderWidth: '2px',
      borderColor: BorderColor,
      alignSelf: 'stretch',
      flexDirection: 'column',
      minHeight: '10%',
      maxHeight: '100%',
      flexShrink: 0,
    },
    headerWrapper: {
      width: '35.5rem',
      height: '6.65rem',
      borderBottom: '2px',
      borderColor: BorderColor,
      alignSelf: 'stretch',
      padding: '1.25rem',
      flexDirection: 'column',
      backgroundColor: WrapperBackgroundColor,
      borderTopLeftRadius: '0.25rem',
      borderTopRightRadius: '0.25rem',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '33rem',
      height: '1.75rem',
      alignSelf: 'stretch',
    },
    numberWrapper: {
      flex: 1,
      padding: '1.25rem',
      gap: '0.625rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignSelf: 'stretch',
      overflowY: 'auto',
    },
    headerText: {
      width: '24.75rem',
      height: '1.25rem',
      textStyle: textStyleKeys.Body2_Bold,
    },
    headerSubtext: {
      width: '34rem',
      height: '1rem',
      textStyle: textStyleKeys.Body2,
      marginTop: '1rem',
    },
    blockedNumberWrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: '0.5rem',
      paddingRight: '0.5rem',
      paddingTop: '0.1rem',
      justifyContent: 'space-between',
      gap: '0.625rem',
      width: '33rem',
      height: '2.25rem',
      border: '1.5px solid',
      borderColor: BorderColor,
      borderRadius: '0.25rem',
      flexShrink: 0,
      backgroundColor: NumberBackgroundColor,
    },
    blockedNumberText: {
      textStyle: textStyleKeys.Body2,
    },
  },
})

export const useBlockedNumberStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof BlockedNumberStyleParts>(
    getName({ BlockedNumberStyles }),
    props,
  )
}
